
export default function ImpactMetrics() {
  const metrics = [
    {
      number: "500+",
      label: "Tons of Waste Processed",
      description: "Organic waste converted into valuable resources annually",
      icon: "ri-recycle-line"
    },
    {
      number: "200+",
      label: "Farmers Trained",
      description: "Agricultural professionals empowered with BSF knowledge",
      icon: "ri-group-line"
    },
    {
      number: "50+",
      label: "Tons of Protein Produced",
      description: "High-quality protein feed supporting livestock nutrition",
      icon: "ri-leaf-line"
    },
    {
      number: "95%",
      label: "Waste Reduction",
      description: "Efficiency in converting organic waste to useful products",
      icon: "ri-bar-chart-line"
    }
  ];

  return (
    <section className="py-20 bg-green-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Our Environmental Impact
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Building a greener future through sustainable practices that protect the environment 
            while creating economic opportunities for communities across Ghana.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {metrics.map((metric, index) => (
            <div key={index} className="bg-white rounded-xl p-8 text-center shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className={`${metric.icon} text-green-600 text-2xl`}></i>
              </div>
              
              <div className="text-4xl font-bold text-green-600 mb-2">{metric.number}</div>
              <div className="text-xl font-semibold text-gray-900 mb-2">{metric.label}</div>
              <p className="text-gray-600 text-sm leading-relaxed">{metric.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-white rounded-xl p-8 shadow-lg">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-6">
                Promoting Circular Economy Practices
              </h3>
              
              <div className="space-y-4">
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center mr-4 mt-1">
                    <i className="ri-check-line text-green-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Environmental Protection</h4>
                    <p className="text-gray-600">Reducing organic waste in landfills and promoting sustainable waste management practices.</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center mr-4 mt-1">
                    <i className="ri-check-line text-green-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Food Security Enhancement</h4>
                    <p className="text-gray-600">Providing sustainable protein sources and organic fertilizers to boost agricultural productivity.</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center mr-4 mt-1">
                    <i className="ri-check-line text-green-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Economic Empowerment</h4>
                    <p className="text-gray-600">Creating income opportunities and empowering farmers with innovative agricultural technologies.</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="relative">
              <img 
                src="https://public.readdy.ai/ai/img_res/f4538cb17f8287c85bdb1363df2ac420.jpg"
                alt="Sustainable Agriculture Impact"
                className="w-full h-80 object-cover object-top rounded-lg"
              />
              <div className="absolute inset-0 bg-green-600/10 rounded-lg"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
